var _style, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitcherTopo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CECECE;}\n\t.st1{fill:#353535;}\n\t.st2{fill:none;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "44.8,21.8 39.5,25.1 10.6,25.1 5.2,21.8 6.3,18.6 25,8.6 44.8,19.7 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,19.7c5.3,0,10.4,1.9,14.5,5.4L25,34l-14.4-8.9C14.6,21.6,19.7,19.7,25,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.5,19.5l-3.8,2.3C33.8,11,16.2,11,5.2,21.8l-3.8-2.3L25,5L48.5,19.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "48.5,30.5 25,45 1.5,30.5 6.3,27.6 25,39.1 43.7,27.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 50,
    height: 50
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitcherTopo);
export default __webpack_public_path__ + "static/media/switcher_topo.cd2251e286ec072f21da174bc2fdd69e.svg";
export { ForwardRef as ReactComponent };